import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import styles from "./ProductBrandAccordion.module.scss";
import { cleanHtml } from "../../../../utils/string/cleanHtml";
import { Brand } from "../../../../types/prodcatBaseTypes";

type Props = {
  brand: Brand | undefined;
  sizeGuide: string | undefined | null;
  open?: boolean;
  disableSizeGuide?: boolean;
};

export function ProductBrandAccordionUI({
  brand,
  sizeGuide,
  open,
  disableSizeGuide,
}: Props) {
  if (!brand?.story && (!sizeGuide || disableSizeGuide)) return null;

  const logo = brand?.logo;
  const name = brand?.name;
  const story = brand?.story;
  const sanitisedBrandStory = cleanHtml(story) || "";
  const sanitisedSizeGuide = cleanHtml(sizeGuide);

  const htmlDataWithSizeGuide = [sanitisedBrandStory, sanitisedSizeGuide].join(
    "",
  );
  const htmlDataWithoutSizeGuide = sanitisedBrandStory;

  const htmlData = disableSizeGuide
    ? htmlDataWithoutSizeGuide
    : htmlDataWithSizeGuide;
  return (
    <Accordion
      className={styles["product-accordion__item"]}
      data-testid="accordion:brand"
      label={brandStorySizeGuideTitle(
        sanitisedBrandStory,
        disableSizeGuide ? "" : sanitisedSizeGuide,
      )}
      animated={true}
      responsive
      open={open}
    >
      {logo && (
        <img
          className={styles.brandImage}
          data-testid="product:brand:logo"
          src={`${logo}?$brand-logo_product$`}
          alt={name}
        />
      )}
      <div
        className={styles.productBrand}
        data-testid="product:brand"
        dangerouslySetInnerHTML={{ __html: htmlData }}
      ></div>
    </Accordion>
  );
}

function brandStorySizeGuideTitle(
  brandStory: string | undefined | null,
  sizeGuide: string | undefined | null,
) {
  let title = "";
  if (brandStory && sizeGuide) {
    title = "Brand information & size guide";
  } else if (brandStory) {
    title = "Brand information";
  } else if (sizeGuide) {
    title = "Size guide";
  }
  return title;
}
